module.exports = "/_next/static/images/associationLogo7-7e90c929878c24435c06ec73977a10fb.webp";